



























































































































import Component, { mixins } from 'vue-class-component';
import { loadWidget } from '@/utils/helpers';
import { namespace } from 'vuex-class';
import { IPaginate, IUssdHit } from '@/types/types';
import { Watch } from 'vue-property-decorator';
import WidgetMixins from '@/mixins/WidgetMixins';
import moment from 'moment';
import qs from 'qs';

const ussdModule = namespace('ussdAdmin');

@Component({
  name: 'UssdHitReports',
  components: {
    InternetConnection: loadWidget('pages/InternetConnection'),
    ToolBar: loadWidget('widgets/ToolBar'),
    SnackBar: loadWidget('widgets/SnackBar'),
    EmptyPage: loadWidget('pages/EmptyPage'),
  },
  filters: {
    numberFormat: (value: number) => (value ?? 0).toLocaleString(),
  },
})
export default class UssdHitReports extends mixins(WidgetMixins) {
  @ussdModule.Getter('getHits') hits!: IUssdHit[];
  @ussdModule.Getter('getHitsPagination') pagination!: IPaginate;
  @ussdModule.Getter('getHitsTotal') totalHits!: number;

  options: any = {};
  query: string = '';
  startDate: string = moment()
    .subtract(30, 'days')
    .format('YYYY-MM-DD');
  endDate: string = moment().format('YYYY-MM-DD');
  network: string = '';
  serviceCode: string = '';
  startMenu: boolean = false;
  endMenu: boolean = false;

  headers = [
    { text: 'Date', value: 'date' },
    { text: 'Network', value: 'network' },
    { text: 'Service Code', value: 'serviceCode' },
    { text: 'Short Code', value: 'shortCode' },
    { text: 'Hits', value: 'totalHits', align: 'end' },
  ];

  buildQuery(page: number = 1, limit: number = 50, extra: object = {}): string {
    return qs.stringify(
      {
        page,
        limit,
        startDate: this.startDate,
        endDate: this.endDate,
        ...(this.network && { network: this.network }),
        ...(this.serviceCode && { serviceCode: this.serviceCode }),
        ...extra,
      },
      { skipNulls: true, addQueryPrefix: true },
    );
  }

  fetchHits(): void {
    this.$store.dispatch('ussdAdmin/fetchHits', this.query);
  }

  download(ext: string): void {
    // CSV streams server-side; xlsx is capped lower and the store surfaces that
    this.$store.dispatch('ussdAdmin/exportHits', this.buildQuery(1, 50, { ext }));
  }

  @Watch('startDate')
  @Watch('endDate')
  @Watch('network')
  @Watch('serviceCode')
  onFilterChange(): void {
    this.query = this.buildQuery();
    this.fetchHits();
  }

  @Watch('options', { deep: true })
  onOptionsChange(paginate: IPaginate): void {
    const query = this.buildQuery(paginate.page, paginate.itemsPerPage);
    if (query === this.query) return;
    this.query = query;
    this.fetchHits();
  }

  created(): void {
    this.query = this.buildQuery();
    this.fetchHits();
  }
}
